import { Space } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { currencyImgs } from 'assets/images/currency';
import { Avatar } from 'components/Avatar';

import { TFunctionCustom } from 'hooks';

interface IPositionColumn {
  coin: any;
  borrow: any;
  position: any;
  positionValue: any;
  indexPrice: any;
}

const columns = (t: TFunctionCustom, precisionsConfigs: any): ColumnsType<IPositionColumn> => [
  {
    title: t('historypage.columns.coin'),
    key: 'coin',
    dataIndex: 'coin',
    sorter: true,
    showSorterTooltip: false,
    render(value: string) {
      return (
        <Space>
          <Avatar noBorder size={20} type="secondary" src={currencyImgs[value] || currencyImgs.GENERIC} />
          <span className="bold default">{value}</span>
        </Space>
      );
    },
  },
  {
    title: t('exchange.columns.position'),
    key: 'position',
    dataIndex: 'position',
    sorter: true,
    showSorterTooltip: false,
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: `${t('exchange.columns.position_value')}(USDT)`,
    key: 'positionValue',
    dataIndex: 'positionValue',
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: `${t('exchange.columns.index_price')}(USDT)`,
    key: 'indexPrice',
    dataIndex: 'indexPrice',
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: `${t('exchange.columns.liquidation_price')}(USDT)`,
    key: 'liquidatePrice',
    dataIndex: 'liquidatePrice',
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: t('exchange.columns.to_liquidation_price'),
    key: 'toLiquidatePrice',
    dataIndex: 'toLiquidatePrice',
    render(value: any) {
      return <span>{value}</span>;
    },
  },
];

export default columns;
